<template>
  <div
    :class="{ favorite: true, clickable: interactiveFavorite }"
    :role="interactiveFavorite ? 'button' : undefined"
    :tabindex="interactiveFavorite ? 0 : -1"
    @click="handleClick"
    @keydown.enter.space.prevent="handleClick"
  >
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :d="starIconFilled"
        :fill="isFavorited || !interactiveFavorite ? '#005C80' : '#E0E0E0'"
      />
    </svg>
  </div>
</template>

<script>
import { starIconFilled } from '../../assets/icon-paths/star-icon';

export default {
  name: 'FavoriteIcon',

  props: {
    isFavorited: {
      type: Boolean,
      default: false,
    },
    interactiveFavorite: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    starIconFilled() {
      return starIconFilled;
    },
  },

  methods: {
    handleClick() {
      if (!this.interactiveFavorite) return;

      this.$emit('toggle', {
        productId: Number(this.productId),
        currentlyFavorited: this.isFavorited,
      });
    },
  },
};
</script>

<style>
.clickable {
  cursor: pointer;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.1);
  }
}
.favorite {
  width: max-content;
  height: max-content;
}
</style>
